// extracted by mini-css-extract-plugin
module.exports = {"pageStyle":"dashboard_pageStyle__3Z1t7","addButton":"dashboard_addButton__xOi5U","noContent":"dashboard_noContent__3O94B"};